import { createSlice } from '@reduxjs/toolkit';
import { SELF_ASSESSMENT_REPORT } from '../../actions/Reports/actionSelfTypes';

const selfAssessmentInitialState = {
  selfAssessment: {
    selfAssessmentdata: [],
    dropDown: [],
    exportFileData: [],
    isLoading: false,
    errors: ''
  }
};

export const selfReportSlice = createSlice({
  name: SELF_ASSESSMENT_REPORT,
  initialState: selfAssessmentInitialState,
  reducers: {
    /* This action will trigger our saga middleware
       and set the loader to true and reset error message.
    */

    getSelfDropDownAction: (state) => {
      state.isLoading = true;
      state.selfAssessment.isLoading = true;
      state.selfAssessment.errors = '';
    },

    getSelfDropDownSuccessAction: (state, action) => {
      if (action.payload) {
        state.selfAssessment.dropDown = action.payload;
        state.selfAssessment.selfAssessmentdata = action.payload;
      }
      state.selfAssessment.isLoading = false;
    },
    getSelfDropDownFailureAction: (state, action) => {
      state.selfAssessment.isLoading = false;
      state.selfAssessment.errors = action.payload;
    },
    getSelfReportAction: (state) => {
      state.isLoading = true;
      state.selfAssessment.errors = '';
      state.selfAssessment.isLoading = true;
    },
    getSelfReportSuccessAction: (state, action) => {
      if (action.payload) {
        state.selfAssessment.selfAssessmentdata = action.payload;
      }
      state.selfAssessment.isLoading = false;
    },
    getSelfReportFailureAction: (state, action) => {
      state.selfAssessment.isLoading = false;
      state.selfAssessment.errors = action.payload;
    },

    getSelfExportFileAction: (state) => {
      state.isLoading = true;
      state.selfAssessment.isLoading = true;
      state.selfAssessment.errors = '';
    },

    getSelfExportFileSuccessAction: (state, action) => {
      if (action.payload) {
        state.selfAssessment.exportFileData = action.payload;
      }
      state.selfAssessment.isLoading = false;
    },

    getSelfExportFileFailureAction: (state, action) => {
      state.selfAssessment.isLoading = false;
      state.selfAssessment.errors = action.payload;
    },

    getEmployeeAction: (state) => {
      state.isLoading = true;
      state.selfAssessment.errors = '';
    },
    getEmployeeSuccessAction: (state, action) => {
      if (action.payload) {
        state.selfAssessment.selfAssessmentdata = action.payload;
      }
      state.selfAssessment.isLoading = false;
    },
    getEmployeeFailureAction: (state, action) => {
      state.selfAssessment.isLoading = false;
      state.selfAssessment.errors = action.payload;
    }
  }
});

/* getUserSuccessAction and getUserErrorAction will be used inside the saga
  middleware. Only getUserAction will be used in a React component.
*/

export const {
  getSelfExportFileAction,
  getSelfExportFileSuccessAction,
  getSelfExportFileFailureAction,
  getSelfReportAction,
  getSelfReportSuccessAction,
  getSelfReportFailureAction,
  getSelfDropDownAction,
  getSelfDropDownSuccessAction,
  getSelfDropDownFailureAction,
  getEmployeeAction,
  getEmployeeSuccessAction,
  getEmployeeFailureAction
} = selfReportSlice.actions;
export default selfReportSlice.reducer;
